import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { RequestDataArray } from 'src/types/requestData';
import { getRequest } from 'src/utils/request';

const mapUserStatus = (attributes: UCM.UserStatusOptionRawType, id: string) => {
  return {
    label: attributes.code,
    value: id,
  };
};

const getUserStatus = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.UserStatusOptionRawType>
  >(API.GET.userStatuses);
  return data?.data?.map(({ attributes, id }) => mapUserStatus(attributes, id));
};

export const useGetUserStatusIdOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.USER_STATUS_ID_OPTIONS],
    queryFn: () => getUserStatus(),
    staleTime: 1000 * 60 * 60, // 1 hour - customer data rarely changes
    gcTime: 1000 * 60 * 60 * 2, // 2 hours - keep in cache longer
    ...config,
  });
};
